import { doc, getDoc } from "firebase/firestore";
import { useEffect, useState } from "react";
import { db } from "../lib/firebase.js";

interface ResolveResult {
  listId: string | null;
  loading: boolean;
  error: string | null;
}

export function useResolveToken(shareToken: string | undefined): ResolveResult {
  const [listId, setListId] = useState<string | null>(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!shareToken) {
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);

    const resolve = async () => {
      try {
        const tokenDoc = await getDoc(doc(db, "shareTokens", shareToken));
        if (!tokenDoc.exists()) {
          setError("この共有リンクは無効か、期限切れです。");
          setLoading(false);
          return;
        }
        const data = tokenDoc.data();
        if (!data.active) {
          setError("この共有リンクは無効化されています。");
          setLoading(false);
          return;
        }
        setListId(data.listId);
        setLoading(false);
      } catch (err) {
        console.error("Failed to resolve token:", err);
        setError("リストの読み込みに失敗しました。もう一度お試しください。");
        setLoading(false);
      }
    };

    resolve();
  }, [shareToken]);

  return { listId, loading, error };
}
